export type PurposeOption = {
  value: string;
  label: string;
  icon: string;
  altText: string;
};

export const purposeOptions: Array<PurposeOption> = [
  {
    value: "NEW_CAR",
    label: "Auto nuova",
    icon: "conte_icon_wizard_new_car",
    altText: "Un'auto nuova in un parcheggio",
  },
  {
    value: "USED_CAR",
    label: "Auto usata",
    icon: "conte_icon_wizard_old_car",
    altText: "Una vecchia auto in un vialetto",
  },
  // { value: 'LIQUIDITY', label: 'Liquidità' },
  {
    value: "DEBT_CONSOLIDATION",
    label: "Consolidamento debiti",
    icon: "conte_icon_wizard_add_money",
    altText: "Un portafogli vuoto",
  },
  {
    value: "MEDICAL_EXPENSES",
    label: "Spese mediche",
    icon: "conte_icon_wizard_healthcare",
    altText: "Due mani che si stringono",
  },
  {
    value: "ESTHETICS_WELLBEING",
    label: "Estetica e Benessere",
    icon: "conte_icon_wizard_beauty",
    altText: "Il volto di una donna",
  },
  {
    value: "STUDYING_TRAINING_COURSES",
    label: "Studio",
    icon: "conte_icon_wizard_studio",
    altText: "Un'aula piena di studenti che seguono una lezione",
  },
  {
    value: "WEDDING",
    label: "Matrimonio",
    icon: "conte_icon_wizard_wedding",
    altText: "Due fedi appoggiate sopra un libro aperto",
  },
  {
    value: "TRAVELS",
    label: "Viaggi",
    icon: "conte_icon_wizard_trip",
    altText: "Un camper in una strada di montagna",
  },
  {
    value: "HOME_IMPROVEMENT",
    label: "Ristrutturazione casa",
    icon: "conte_icon_wizard_house_improv",
    altText: "L'interno di una casa finemente arredata",
  },
  {
    value: "REAL_ESTATE_BOX_PURCHASE",
    label: "Acquisto Box",
    icon: "conte_icon_wizard_box",
    altText: "Il retro di un auto dentro un garage",
  },
  {
    value: "NEW_USED_MOTORBIKE",
    label: "Moto nuova o usata",
    icon: "conte_icon_wizard_bike",
    altText: "Una moto in una strada",
  },
  {
    value: "FURNITURE",
    label: "Arredamento",
    icon: "conte_icon_wizard_furnitures",
    altText: "Un divano in un soggiorno",
  },
  {
    value: "OTHER",
    label: "Altre spese",
    icon: "conte_icon_wizard_other",
    altText: "Un insieme di post-it appesi",
  },
];
